export const newMailAction = "h_a";
export const newNoteAction = "i_a";
export default {newMailAction,newNoteAction};